module.exports = __webpack_public_path__ + "static/media/postman.058b575a.png";